import Grid from './Grid'

export default {
  name: 'grid',
  configure: function(config) {
    config.addComponent('grid', Grid)
  }
}
